<template>
  <div class="wrapper">
    <keep-alive :include="includeRoutes">
      <router-view></router-view>
    </keep-alive>
  </div>
</template>


<style scoped lang="scss">
</style>

<script>
export default {
  name: "DataLayout",
  data() {
    return {
      includeRoutes: []
    };
  },
  mounted() {},

  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/pages/datav/layout.vue